/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useRef, useState } from 'react';
import Slider from "react-slick";
import { GoArrowRight } from "react-icons/go";
import { FiPlus } from "react-icons/fi";
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { MyContext } from '../Context/MyProvider';
import BookingDetails from './DocAppointment/BookingDetails';
import AddPatient from './DocAppointment/AddPatient';
import { FaStar } from "react-icons/fa";
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
import { LuFlaskConical, LuHouse, LuPill, LuQrCode, LuStethoscope } from "react-icons/lu";
import { RiMapPin2Line, RiMapPinLine } from "react-icons/ri";
import OneSignal from 'react-onesignal';
import { useTranslation } from 'react-i18next';
import LocationImg from "../assets/Image/permission.png";
import { showToast } from '../showTost';
import Loading from './Loading';
import NotificationImg from "../assets/Image/Notification.png";
import secureLocalStorage from "react-secure-storage";
import { applyImageFallback, buildImageUrl } from '../utils/image';
import { normalizeInternalPath } from '../utils/routes';
import HomeCareBook from './HomeCare/HomeCareBook';
import HomeVisitRequest from './HomeVisit/HomeVisitRequest';

const HOME_SERVICE_TILE_IMAGES = {
    doctor: "/images/service-tiles/doctor.jpg",
    lab: "/images/service-tiles/lab.jpg",
    pharmacy: "/images/service-tiles/pharmacy.jpg",
    homeCare: "/images/service-tiles/home-care.jpg",
    payApp: "/images/service-tiles/pay-app.jpg",
    map: "/images/service-tiles/map.jpg",
};

const CustomPrevArrow = ({ onClick }) => (
    <div
        onClick={onClick}
        className="bg-rm-primary p-[3px] rounded-[50px] absolute z-10 right-[40px] -top-[34px] transform -translate-y-1/2 cursor-pointer shadow-rm"
    >
        <MdChevronLeft color="#fff" size={22} />
    </div>
);

const CustomNextArrow = ({ onClick }) => (
    <div
        onClick={onClick}
        className="bg-rm-primary p-[3px] rounded-[50px] absolute z-10 right-[0px] -top-[34px] transform -translate-y-1/2 cursor-pointer shadow-rm"
    >
        <MdChevronRight color="#fff" size={22} />
    </div>
);


const Dashboard = () => {
    const { t } = useTranslation();
    const { ApiBaseUrl, ImgBaseUrl, patientStatus, isLogin, setAgoraAppId, setMapKey, setIsLoginShow, paymentStatus, setPaymentStatus, applyGeneralSettings } = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [sliderImg, setSliderImg] = useState([]);
    const [bookingData, setBookingData] = useState();
    const [isBooking, setIsBooking] = useState(false);
    const [familyMemberList, setFamilyMemberList] = useState([]);
    const [isPatient, setIsPatient] = useState(false);
    const [relationshipData, setRelationshipData] = useState([]);
    const [booldData, setBooldData] = useState([]);
    const [patientData, setPatientData] = useState();
    const [favoritList, setFavoriteList] = useState([]);
    const [dynamicList, setDynamicList] = useState([]);
    const [homeCareServices, setHomeCareServices] = useState([]);
    const [careFrom, setCareFrom] = useState(null);
    const [hcBookId, setHcBookId] = useState(null);
    const [hvBookOpen, setHvBookOpen] = useState(false);
    const [deviceCheck, setDeviceCheck] = useState(false);
    const [locationError, setLocationError] = useState(false);
    const [notificationerror, setNotificationError] = useState(false);


    const navigate = useNavigate();
    const initialized = useRef(false);

    const settings = {
        arrows: false,
        dots: false,
        infinite: true,
        centerMode: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,
        // autoplay: true,
        // autoplaySpeed: 3000,
        responsive: [
            { breakpoint: 1310, settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 770, settings: { slidesToShow: 1, slidesToScroll: 1, centerMode: false } },
        ],
    };

    const Patientsetting = {
        arrows: false,
        dots: false,
        infinite: false,
        speed: 1000,
        slidesToShow: 10,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
            { breakpoint: 1605, settings: { slidesToShow: 8, slidesToScroll: 1 } },
            { breakpoint: 1445, settings: { slidesToShow: 7, slidesToScroll: 1 } },
            { breakpoint: 1305, settings: { slidesToShow: 7, slidesToScroll: 1 } },
            { breakpoint: 1205, settings: { slidesToShow: 7, slidesToScroll: 1 } },
            { breakpoint: 995, settings: { slidesToShow: 6, slidesToScroll: 1 } },
            { breakpoint: 770, settings: { slidesToShow: 5, slidesToScroll: 1 } },
            { breakpoint: 580, settings: { slidesToShow: 4, slidesToScroll: 1 } },
            { breakpoint: 430, settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 380, settings: { slidesToShow: 2, slidesToScroll: 1 } },
        ],
    };

    const boxsetting = {
        arrows: true,
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 1,
        initialSlide: 0,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
        responsive: [
            { breakpoint: 1445, settings: { slidesToShow: 4, slidesToScroll: 1 } },
            { breakpoint: 1030, settings: { slidesToShow: 3, slidesToScroll: 1 } },
            { breakpoint: 770, settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 430, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ],
    };

    const labsetting = {
        arrows: true,
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 0,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
        responsive: [
            { breakpoint: 1445, settings: { slidesToShow: 3, slidesToScroll: 1 } },
            { breakpoint: 770, settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 580, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ],
    };

    useEffect(() => {
        window.scrollTo(0, 0);

        try {
            if (typeof Notification !== "undefined" && Notification.permission === "denied") {
                if (!secureLocalStorage.getItem("notification")) {
                    setNotificationError(true);
                }
            }
        } catch (error) {
            /* iOS Safari often has no Notification API */
        }

        const fallbackLat = "17.3850";
        const fallbackLon = "78.4867";
        fetchHomeData(fallbackLat, fallbackLon);
        HandleGetmember();

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                position => {
                    fetchHomeData(String(position.coords.latitude), String(position.coords.longitude));
                },
                error => {
                    if (!secureLocalStorage.getItem("location")) {
                        setLocationError(true);
                    }
                },
                { enableHighAccuracy: false, timeout: 8000, maximumAge: 300000 }
            );
        }

    }, [isLogin]);

    const fetchHomeData = (lat, long) => {
        setLoading(true);

        const Userid = secureLocalStorage.getItem("Userid") || "0";

        axios.post(`${ApiBaseUrl}/customer/home`, { id: Userid, lat: lat, lon: long })
            .then((res) => {
                const { banner_data, general_currency, ResponseCode, fav_doctor_list, dynamic_list } = res.data;
                // console.log("Home Data", res.data);
                if (ResponseCode === 200) {
                    setLoading(false);
                    setSliderImg(banner_data);
                    setFavoriteList(fav_doctor_list);
                    setDynamicList(dynamic_list);
                    if (general_currency) {
                        applyGeneralSettings(general_currency);
                        if (general_currency.one_app_id_react) {
                            OneSignalHandle(general_currency.one_app_id_react);
                        }
                        if (general_currency.agora_app_id) setAgoraAppId(general_currency.agora_app_id);
                        if (general_currency.google_map_key) setMapKey(general_currency.google_map_key);
                    }
                }
            })
            .catch((error) => {
                console.error("Home Api", error);
            });

        axios.get(`${ApiBaseUrl}/hc/customer/services`)
            .then((res) => {
                if (res.data?.Result) setHomeCareServices(res.data.services || []);
            })
            .catch((error) => {
                console.error("Home Care services", error);
            });

        axios.post(`${ApiBaseUrl}/subscription/plans`, {})
            .then((res) => {
                const priced = (res.data.plans || []).filter((p) => Number(p.price) > 0);
                if (priced.length) setCareFrom(Math.min(...priced.map((p) => Number(p.price))));
            })
            .catch(() => {});

    }

    useEffect(() => {
        if (patientStatus) {
            HandleGetmember();
            setIsPatient(false);
        }
    }, [patientStatus])

    const HandleGetmember = () => {
        const Userid = secureLocalStorage.getItem("Userid");


        if (Userid) {
            axios.post(`${ApiBaseUrl}/customer/family_member_list`, { id: Userid })
                .then((res) => {
                    // console.log(res);
                    setFamilyMemberList(res.data.family_member);
                })
                .catch((error) => {
                    console.error(error);
                })

            axios.get(`${ApiBaseUrl}/customer/family_member_add_detail`)
                .then((res) => {
                    const { relationship_list, blood_group_list } = res.data;
                    setRelationshipData(relationship_list);
                    setBooldData(blood_group_list);
                })
                .catch((error) => {
                    console.error(error);
                })
        }
    }

    useEffect(() => {
        const status = sessionStorage.getItem("Bookid");
        if (status) {
            HandleBookAppointGet(status);
        }
    }, []);

    const HandleBookAppointGet = (id) => {
        const Userid = secureLocalStorage.getItem("Userid");

        if (Userid) {
            axios.post(`${ApiBaseUrl}/customer/success_appo_detail`, { id: Userid, appointment_id: id })
                .then((res) => {
                    // console.log("success_appo_detail", res);
                    setIsBooking(true);
                    setBookingData(res.data);
                    sessionStorage.removeItem("Bookid");
                })
                .catch((error) => {
                    console.error("success_appo_detail", error);
                })
        }
    }

    const HandleGetPatientDetails = (id) => {
        axios.post(`${ApiBaseUrl}/customer/family_member_detail`, { fid: id })
            .then((res) => {
                // console.log(res);
                setPatientData(res.data.data);
                setIsPatient(true);
            })
            .catch((error) => {
                console.error(error);
            })
    }

    const HandleNavigateDoc = (title, Id, departmentid) => {
        sessionStorage.setItem("Docprofile", JSON.stringify({ id: Id, department_id: departmentid, title, path: "/", pagename: "Home" }));
        navigate(`/doctor-profile/${Id}`);
    }

    const HandleNavigateLab = (item, category) => {
        sessionStorage.setItem("Docprofile", JSON.stringify({ Categoryid: category, Labid: item.id, title: "Home", path: "/" }));
        navigate("/packages");
    }


    const OneSignalHandle = (AppId) => {
        const Userid = secureLocalStorage.getItem("Userid");

        if (Userid && !initialized.current) {
            OneSignal.init({
                appId: AppId,
                safari_web_id: "web.onesignal.auto.xxx",
                notifyButton: {
                    enable: true,
                },
                serviceWorkerParam: { scope: "/" },
                serviceWorkerPath: "OneSignalSDKWorker.js",
                allowLocalhostAsSecureOrigin: true,
            }).then(() => {

                initialized.current = true;

                OneSignal.User.addTags({
                    "user_id": Userid,
                });
            })
                .catch((error) => {
                    console.error("OneSignal :-->>", error);
                });
        }
    }

    const openBannerLink = (item) => {
        const type = String(item?.link_type || "").toLowerCase();
        const url = String(item?.link_url || item?.link || "").trim();

        if (type === "none" || !url) return;

        if (/^(tel:|mailto:|whatsapp:)/i.test(url)) {
            window.location.href = url;
            return;
        }

        let target;
        try {
            target = new URL(url, window.location.origin);
        } catch (_) {
            return;
        }

        if (target.origin === window.location.origin) {
            navigate(normalizeInternalPath(`${target.pathname}${target.search}${target.hash}`));
            return;
        }

        if (type === "url" || type === "app" || target.protocol === "http:" || target.protocol === "https:") {
            window.open(target.href, "_blank", "noopener,noreferrer");
            return;
        }

        if (item?.department) {
            sessionStorage.setItem("Docdetails", JSON.stringify({
                id: item.department,
                title: item.department_name,
                path: "/",
                pagename: "Home"
            }));
            navigate("/doctor-details");
        }
    };

    useEffect(() => {
        document.body.style.overflow = "auto";
    }, [loading]);

    const HandleAddPatient = () => {
        const Userid = secureLocalStorage.getItem("Userid");
        if (Userid) {
            setIsPatient(true);
            setPatientData("");
        } else {
            setIsLoginShow(true);
        }
    }

    useEffect(() => {
        if (!paymentStatus) return;

        if (paymentStatus === "PaymentFaild") {
            showToast({ title: "Payment Closed !!", id: "info" });
            setPaymentStatus("");
        }
    }, [paymentStatus]);

    const HandleLocationEnable = () => {
        setLocationError(false);
        secureLocalStorage.setItem("location", true);
        fetchHomeData(21.215814, 72.828308);

    }

    const HandleNotificationEnable = () => {
        setNotificationError(false);
        secureLocalStorage.setItem("notification", true);
    }

    return (
        <div className="dashboard">
            {false ? <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-rm-bg" />
                : <div className=''>
                    <div className="rm-hero-wash rm-fade-up">
                        <div className="rm-hero-copy">
                            <span className="eyebrow">RapidMediK</span>
                            <h1>Care that comes to you</h1>
                            <p>Book doctors, labs, medicines, and home visits — with the same warm experience as the app.</p>
                        </div>
                        <div className="banner slider-container mt-[12px]">
                            {sliderImg.length > 0 && (
                            <Slider {...settings} infinite={sliderImg.length > 3} centerMode={sliderImg.length > 2}>
                                {
                                    sliderImg.map((item, index) => {
                                        return <div onClick={() => openBannerLink(item)} className=' relative overflow-hidden cursor-pointer' key={index}>
                                            <img src={buildImageUrl(ImgBaseUrl, item.image, "banner")} onError={(e) => applyImageFallback(e, ImgBaseUrl, "banner")} className='dash_slider_img' alt="Slider Img" />
                                        </div>
                                    })
                                }
                            </Slider>
                            )}
                        </div>
                    </div>

                    <div className="width-container">

                        <div className="section-2 mb-[25px]">
                            <div className="car-gallery">
                                {[
                                    { to: "/services", tint: "#FFEB68", image: HOME_SERVICE_TILE_IMAGES.doctor, Icon: LuStethoscope, title: `${t("Doctor Appointment")} ${t("Book")}` },
                                    { to: "/lab-tests", tint: "#FEC091", image: HOME_SERVICE_TILE_IMAGES.lab, Icon: LuFlaskConical, title: t("Lab Booking") },
                                    { to: "/pharmacy", tint: "#FFD6EF", image: HOME_SERVICE_TILE_IMAGES.pharmacy, Icon: LuPill, title: t("Medicine Booking") },
                                    { to: "/home-care", tint: "#C8E7FF", image: HOME_SERVICE_TILE_IMAGES.homeCare, Icon: LuHouse, title: "Home Care" },
                                    { to: "/pay-app", tint: "#D8F5C8", image: HOME_SERVICE_TILE_IMAGES.payApp, Icon: LuQrCode, title: "Pay via App" },
                                    { to: "/map", tint: "#E8D5FF", image: HOME_SERVICE_TILE_IMAGES.map, Icon: RiMapPin2Line, title: "Doctors Map" },
                                ].map((tile) => (
                                    <Link
                                        key={tile.to}
                                        to={tile.to}
                                        className="rm-service-card"
                                        style={{
                                            "--card-tint": tile.tint,
                                            "--card-image": `url(${tile.image})`,
                                        }}
                                    >
                                        <div className="rm-service-card__content">
                                            <tile.Icon className="rm-service-card__icon" aria-hidden />
                                            <h1 className="title">{tile.title}</h1>
                                            <span className="rm-service-card__cta" aria-hidden>
                                                <GoArrowRight className="text-[20px]" />
                                            </span>
                                        </div>
                                    </Link>
                                ))}
                            </div>
                        </div>

                        <div className="rm-home-visit-band my-[28px] rm-fade-up" style={{ animationDelay: "120ms" }}>
                            <div>
                                <h2>Home visit</h2>
                                <p>Doctor at your doorstep — same as the app.</p>
                            </div>
                            <div className="actions">
                                <Link to="/home-visit/bookings" className="rm-btn-ghost">My visits</Link>
                                <button
                                    type="button"
                                    className="rm-btn-light"
                                    onClick={() => {
                                        const uid = secureLocalStorage.getItem("Userid");
                                        if (!uid) { setIsLoginShow(true); return; }
                                        setHvBookOpen(true);
                                    }}
                                >Book now</button>
                            </div>
                        </div>

                        <div className="rm-home-visit-band my-[28px] rm-fade-up" style={{ animationDelay: "160ms" }}>
                            <div>
                                <h2>Pay via App</h2>
                                <p>Scan at any partner clinic, lab or pharmacy and save on the spot.</p>
                            </div>
                            <div className="actions">
                                <Link to="/pay-app/history" className="rm-btn-ghost">My payments</Link>
                                <Link to="/pay-app" className="rm-btn-light">Find partners</Link>
                            </div>
                        </div>

                        <div className="rm-promo-grid my-[28px] rm-fade-up" style={{ animationDelay: "200ms" }}>
                            <Link to="/subscription" className="rm-promo-card">
                                <span className="rm-promo-kicker">RapidCare Membership</span>
                                <h3>Included consults every month</h3>
                                <p>Teleconsults, nursing visits and up to 20% off every diagnostic test.{careFrom ? ` From ₹${careFrom}/month.` : ""}</p>
                                <span className="rm-promo-cta">See plans →</span>
                            </Link>
                            <Link to="/equipment-rental" className="rm-promo-card">
                                <span className="rm-promo-kicker">Equipment Rental</span>
                                <h3>Wheelchairs, beds &amp; monitors</h3>
                                <p>Delivered to your door on a refundable deposit and a simple daily rate.</p>
                                <span className="rm-promo-cta">Browse equipment →</span>
                            </Link>
                        </div>

                        {homeCareServices.length > 0 && (
                            <div className="home-care-home my-[25px]">
                                <div className="flex items-center justify-between gap-3 mb-[10px]">
                                    <h1 className='title mb-0'>Home Care</h1>
                                    <Link to="/home-care" className="font-[600] text-rm-primary whitespace-nowrap">
                                        View All
                                    </Link>
                                </div>
                                <p className="font-[500] -mt-[5px] mb-[15px] text-rm-muted">Nurses, physios & caregivers at your doorstep</p>
                                <div className="home-care-cards">
                                    {homeCareServices.slice(0, 4).map((item) => (
                                        <div
                                            key={item.id}
                                            onClick={() => {
                                                const uid = secureLocalStorage.getItem("Userid");
                                                if (!uid) { setIsLoginShow(true); return; }
                                                setHcBookId(item.id);
                                            }}
                                            className="home-care-card border border-rm-line rounded-[18px] p-[16px] cursor-pointer bg-white"
                                        >
                                            <p className="text-[12px] uppercase text-rm-primary font-[600] tracking-wide">{item.category_name}</p>
                                            <h3 className="font-[700] text-[18px] mt-[6px] whitespace-nowrap overflow-hidden overflow-ellipsis">{item.name}</h3>
                                            <p className="text-[14px] text-rm-muted mt-[8px] line-clamp-2 min-h-[40px]">{item.description}</p>
                                            <div className="flex items-center justify-between mt-[14px]">
                                                <div>
                                                    <p className="font-[700] text-[16px]">₹{item.base_price}</p>
                                                    <p className="text-[12px] text-rm-muted">{item.duration_minutes} mins</p>
                                                </div>
                                                <span className="bg-rm-gradient text-white text-[13px] font-[600] px-[12px] py-[6px] rounded-[10px]">Book</span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        <div className="patient">
                            <h1 className='title mb-[10px]'>{t("My Patient")}</h1>
                            <div className="slider-container mt-[20px]">
                                <Slider {...Patientsetting}>
                                    <div onClick={HandleAddPatient} className="add_box">
                                        <div className="add bg-[#FFE0C2]">
                                            <h1><FiPlus /></h1>
                                        </div>
                                        <h1 className='p_name'>{t("Add New")}</h1>
                                    </div>
                                    {familyMemberList.map((item, index) => {
                                        return <div onClick={() => HandleGetPatientDetails(item.id)} key={index} className="add_box">
                                            <div className="add">
                                                <img src={buildImageUrl(ImgBaseUrl, item.profile_image, "patient")} onError={(e) => applyImageFallback(e, ImgBaseUrl, "patient")} className='w-[100%] h-[100%] object-cover' alt="" />
                                            </div>
                                            <h1 className='p_name'>{item.name}</h1>
                                        </div>
                                    })}
                                </Slider>
                            </div>
                        </div>

                        {favoritList.length >= 1 && <div className="favorite my-[25px]">
                            <h1 className='title mb-[10px]'>{t("Your favorites")}</h1>
                            <h1 className='font-[500] -mt-[10px] text-rm-muted'>{t("Doctor your Love")}</h1>
                            <div className="slider-container mt-[20px]">
                                <Slider {...Patientsetting}>
                                    {favoritList.map((item, index) => {
                                        return <div onClick={() => HandleNavigateDoc("Doctor Profile", item.id, item.department_id)} key={index} className="add_box cursor-pointer">
                                            <div className="add">
                                                <img src={buildImageUrl(ImgBaseUrl, item.logo, "doctor")} onError={(e) => applyImageFallback(e, ImgBaseUrl, "doctor")} className='w-[100%] h-[100%] object-cover' alt="" />
                                            </div>
                                            <h1 className='text-[16px] mt-[10px] font-[600]'>{item.title}</h1>
                                        </div>
                                    })}
                                </Slider>
                            </div>
                        </div>}

                        <div className="dynamic_list">
                            {dynamicList.map((item, index) => {
                                if ((item.module === "Doctor" || item.module === "Hospital")) {
                                    return <div key={index} className="my-[25px]">
                                        <h1 className='title'>{item.title}</h1>
                                        <div className="slider-container mt-[20px]">
                                            <Slider {...boxsetting}>
                                                {item.details.map((item, index) => {
                                                    return <div key={index} onClick={() => HandleNavigateDoc(item.name, item.id, item.department_id)} className="doctor_box">
                                                        <div className="relative">
                                                            <img src={buildImageUrl(ImgBaseUrl, item.logo, "doctor")} onError={(e) => applyImageFallback(e, ImgBaseUrl, "doctor")} className='w-[100%] h-[350px] object-cover' alt="" />
                                                            <div className="absolute top-[5px] left-[5px] rating_blur">
                                                                <h1 className='flex items-center text-white gap-[5px] font-[500]'><FaStar className='text-orange-400 text-[17px]' />{item.avg_star}</h1>
                                                            </div>
                                                        </div>
                                                        <div className="p-[10px] w-[100%]">
                                                            <h1 className='font-[500] text-[18px] whitespace-nowrap overflow-ellipsis overflow-hidden'>{item.name}</h1>
                                                            <div className="flex items-center gap-[10px] justify-between">

                                                                <h1 className='flex items-center gap-[5px] font-[500] text-gray-600'>
                                                                    <RiMapPinLine className='text-[16px] shrink-0' aria-hidden />
                                                                    {item.distance} KM
                                                                </h1>
                                                            </div>
                                                        </div>
                                                    </div>
                                                })}
                                            </Slider>
                                        </div>
                                    </div>
                                } else if (item.module === "Lab") {
                                    return <div key={index} className="">
                                        <h1 className='title'>{item.title}</h1>
                                        <div className="slider-container mt-[20px]">
                                            <Slider {...labsetting}>
                                                {item.details.map((Item, index) => {
                                                    return <div key={index} onClick={() => HandleNavigateLab(Item, item.category)} className="border-[1px] rounded-[10px] p-[10px] cursor-pointer">
                                                        <div className="flex items-center gap-[10px]">
                                                            <img src={buildImageUrl(ImgBaseUrl, Item.logo, "lab")} onError={(e) => applyImageFallback(e, ImgBaseUrl, "lab")} className='w-[80px] h-[90px] object-cover rounded-[10px]' alt="" />
                                                            <div className="overflow-hidden w-full">
                                                                <h1 className='font-[500] text-[18px] whitespace-nowrap overflow-hidden overflow-ellipsis'>{Item.name}</h1>
                                                                <p className='text-[14px] text-gray-600 whitespace-nowrap overflow-hidden overflow-ellipsis'>{Item.address}</p>
                                                                <div className="flex items-center gap-[10px] justify-between">
                                                                    <h1 className='flex items-center gap-[5px] font-[500]'><FaStar className='text-orange-400 text-[17px]' />{Item.avg_star} <span className='text-gray-500'>({Item.tot_review})</span> </h1>
                                                                    <h1 className='flex items-center gap-[5px] font-[500] text-gray-600'>
                                                                        <RiMapPinLine className='text-[16px] shrink-0' aria-hidden />
                                                                        {Item.distance} KM
                                                                    </h1>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                })}
                                            </Slider>
                                        </div>
                                    </div>
                                }
                            })}
                        </div>

                    </div>
                </div>}

            {isBooking && <div className="flex bg-[#00000069] h-full justify-center w-full fixed items-center left-0 top-0 z-[999]">
                <div className="bottme-box">
                    <BookingDetails Data={bookingData} />
                </div>
            </div>}

            {isPatient && <div onClick={() => setIsPatient(false)} className='flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]'>
                <div onClick={(e) => e.stopPropagation()} className="add-patient">
                    <AddPatient Relation={relationshipData} BooldType={booldData} Data={patientData} />
                </div>
            </div>}

            {deviceCheck && <div onClick={() => setDeviceCheck(false)} className="px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-[15px] p-4">
                    <h6 className='m-0 font-[500] text-[18px] text-gray-600'>{t("Required for voice and video calls. Make")} <br /> {t("sure your audio device (headset, speakers,")} <br /> {t("or microphone) is connected and working.")}</h6>
                </div>
            </div>}

            {locationError && (
                <div className="px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                    <div className="w-full max-w-md mx-auto max-_768_:w-[75%] max-_1030_:w-[35%] max-_1500_:w-[25%] bg-white rounded-[15px] px-[15px] py-[10px]">
                        <div className="">
                            <h2 className="m-0 text-center">{t('Enable Location Services')}</h2>
                            <img src={LocationImg} alt="" />
                            <div className="my-3">
                                <div className="flex gap-[10px]">
                                    <span className="text-[18px]">1.</span>
                                    <h6>{t("To provide accurate services, please enable your location.")}</h6>
                                </div>
                                <div className="flex gap-[5px]">
                                    <span className="text-[18px]">2.</span>
                                    <h6> {t("Allow location access when prompted. If not prompted, enable it in your browser settings.")}</h6>
                                </div>
                                <h6>🔄 {t("Refresh the page after enabling.")}</h6>
                            </div>
                            <button onClick={HandleLocationEnable} className="bg-[#0d9488] text-white w-[100%] rounded-[5px] py-[5px] mt-2 font-[500]">{t("Enable Now")}</button>
                            <button onClick={HandleLocationEnable} className="border-[1px] border-[#0d9488] text-[#0d9488] w-[100%] rounded-[5px] py-[5px] mt-2 font-[500]">{t("Default")}</button>
                        </div>
                    </div>
                </div>
            )}

            {notificationerror && (
                <div className="px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                    <div className="w-full max-w-md mx-auto max-_768_:w-[75%] max-_1030_:w-[35%] max-_1500_:w-[25%] bg-white rounded-[15px] px-[15px] py-[10px]">
                        <div className="">
                            <h2 className="m-0 text-center font-bold">{t("Enable Smart Alerts")}</h2>
                            <img src={NotificationImg} className='w-[100%] rounded-[10px]' alt="" />
                            <div className="my-3">
                                <div className="flex gap-[10px]">
                                    <span className="text-[18px]">1.</span>
                                    <h6>{t("Let us notify you about upcoming bookings, changes, and key updates directly through your browser.")}</h6>
                                </div>
                                <h6>🔄 {t("Refresh the page after enabling.")}</h6>
                            </div>
                            <button onClick={HandleNotificationEnable} className="bg-[#0d9488] text-white w-[100%] rounded-[5px] py-[5px] mt-2 font-[500]">{t("Enable Now")}</button>
                        </div>
                    </div>
                </div>
            )}
            {hcBookId && (
                <HomeCareBook serviceId={hcBookId} onClose={() => setHcBookId(null)} />
            )}
            {hvBookOpen && (
                <HomeVisitRequest onClose={() => setHvBookOpen(false)} />
            )}
        </div>
    )
}

export default Dashboard;
/* jshint ignore:end */